/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ISeparatorStyleProps, ISeparatorStyles } from '@fluentui/react/lib/Separator';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { LuisSeparator } from 'src/core/components/LuisSeparator';
import { getScopedTheme } from 'src/core/themes/luisStylist';

export type TestPaneSeparatorProps = {
    /**
     * The type of the separator if it is the one in the header section,
     * the one separating between sections, or the one separating between
     * subsections.
     */
    separatorType?: 'headerSeparator' | 'mainSeparator' | 'secondarySeparator';
};

const separatorTheme = getScopedTheme('TestPaneSeparator');

/**
 * Displays the separator in the test pane with different
 * options.
 */
export const TestPaneSeparator = (props: TestPaneSeparatorProps) => {
    const { separatorType = 'mainSeparator' } = props;

    let separatorColor = separatorTheme.mainSeparatorColor;

    switch (separatorType) {
        case 'headerSeparator':
            separatorColor = separatorTheme.headerSeparatorColor;
            break;
        case 'secondarySeparator':
            separatorColor = separatorTheme.secondarySeparatorColor;
            break;
        case 'mainSeparator':
        default:
            separatorColor = separatorTheme.mainSeparatorColor;
    }

    const separatorStyles = classNamesFunction<ISeparatorStyleProps, ISeparatorStyles>()({
        content: separatorType !== 'secondarySeparator' && { marginTop: '14px', marginBottom: '14px' },
        root: {
            marginTop: separatorType === 'secondarySeparator' && '10px !important',
            selectors: {
                '&::before': {
                    backgroundColor: `${separatorColor} !important`
                }
            }
        }
    });

    return <LuisSeparator styles={separatorStyles} />;
};
